import { Component } from 'react';
import Header from '../../Header';
import MessageLink from '../../MessageLink';
import Footer from '../../Footer';
import Lgpd from '../../Lgpd';
import RelatoriosAnuais from '../../RelatoriosAnuais';
import ErrorBoundary from '../../ErrorHandler/ErrorBoundary';
import InfoComponent from '../InfoComponent';

class RelatorioAnualDeInformacoes extends Component {

	render() {

		return (

			<div>
				{/* HEADER */}{/* LOGIN */}
				<ErrorBoundary><Header /></ErrorBoundary>

				<InfoComponent image={"relatorio-anual-informacoes"} page={'relatorio-anual-informacoes'}></InfoComponent>
				
				{/* Content page */}
				<div className="_the-content pb-10">
					<div className='container'>
						<div className="row justify-content-center">

							<ErrorBoundary><RelatoriosAnuais fileImg={'../../assets/img/RAI_Prancheta 1.png'} /></ErrorBoundary>

						</div>
					</div>
				</div>
				{/*  <ScrollInfinito/> */}
				{/* FOOTER */}
				<ErrorBoundary><Footer /></ErrorBoundary>
				{/* Message Link */}
				<ErrorBoundary><MessageLink /></ErrorBoundary>
				{/* LGPD */}
				<ErrorBoundary><Lgpd /></ErrorBoundary>
			</div>
		);
	}
};

export default RelatorioAnualDeInformacoes;